{
  "attribution.title": "Attributions",
  "common.close": "Close",
  "common.feature": "Feature {id}",
  "identify.close": "Close identification",
  "identify.dialogLabel": "Identification result",
  "identify.failed": "Identification failed",
  "identify.identifying": "Identifying",
  "identify.noFeature": "No feature found",
  "identify.title": "Identification",
  "layers.collapse": "Collapse {title}",
  "layers.defaultTitle": "Layer",
  "layers.expand": "Expand {title}",
  "layers.hideAll": "None",
  "layers.hideAllTitle": "Hide all layers",
  "layers.legendCollapse": "Collapse legend {title}",
  "layers.legendExpand": "Expand legend {title}",
  "layers.loading": "Loading layers",
  "layers.panelLabel": "Layers panel",
  "layers.showAll": "All",
  "layers.showAllTitle": "Show all layers",
  "layers.title": "Layers",
  "measure.area": "Measure area",
  "measure.close": "Close measurement",
  "measure.distance": "Measure distance",
  "search.failed": "Search failed",
  "search.label": "Search",
  "search.noResults": "No results",
  "search.placeholder": "Start typing",
  "search.searching": "Searching",
  "tools.identify": "Identify features",
  "zoom.home": "Back to the initial extent",
  "zoom.in": "Zoom in",
  "zoom.out": "Zoom out"
}
